import React from 'react';
import { Reveal } from './Reveal';
const stats = [['+300', 'ACTIVITIES READY'], ['+2,000', 'TEACHERS SATISFIED'], ['3,500+', 'HOURS SAVED'], ['99%', 'WOULD RECOMMEND IT']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-347">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-348">
        {stats.map(([value, label], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-349">
            <span className="mb-1 font-serif text-3xl font-bold md:text-4xl" data-id="element-350">
              {value}
            </span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-351">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}